import classnames from 'classnames'
import { Component } from 'react'
import IconSVG from 'svg-inline-react'
import { Button, Icon }  from '@driftt/tide-core-legacy'
import EmailInviteModal from 'components/settings/team/EmailInviteModal'
import PropTypes from 'prop-types'

const closeIconSrc = require('!svg-inline?removeTags=true!images/icons/times-icon.svg')

class InstallDriftNotice extends Component {
  constructor(props) {
    super(props)

    this.state = {
      closed: true,
      showInviteModal: false,
    }
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
  }

  componentDidMount() {
    if (window.sessionStorage && !JSON.parse(window.sessionStorage.getItem('hide-install-notice'))) {
      this.timeout = setTimeout(this.setOpen, 5000)
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  hideForSession = () => {
    if (window.sessionStorage) {
      window.sessionStorage.setItem('hide-install-notice', true)
    }
    this.setClose()
  }

  showWarning = () => {
    this.setState({ showWarning: true })
  }

  setClose = () => {
    this.setState({ closed: true })
  }

  setOpen = () => {
    this.setState({ closed: false })
  }

  redirectToSettings = () => {
    this.context.router.push('/settings/widget')
  }

  showInviteModal = () => {
    this.setState({ showInviteModal: true })
  }

  closeInviteModal = () => {
    this.setState({ showInviteModal: false })
  }

  render() {
    const { closed } = this.state
    const showBar = !closed ? 'show-bar' : ''
    const noticeMessage = <p>We noticed you haven&rsquo;t installed Drift yet &ndash; keep getting setup!</p>

    return (
      <div className={classnames('global-notification-tease attention', { ['show-bar']: showBar })}>
        {noticeMessage}

        <Button type="tertiary" className="notification-button drift-button small" onClick={this.redirectToSettings}>
          Install Drift
        </Button>
        <Button type="tertiary" className="notification-button drift-button small" onClick={this.showInviteModal}>
          Send Drift snippet to a teammate
        </Button>
        <div className="dismiss-notification" onClick={this.hideForSession}>
          <Icon name="close" />
        </div>
        {this.state.showInviteModal && (
          <EmailInviteModal
            onClose={this.closeInviteModal}
            skipRedirect={true}
            onSend={this.hideForSession}
          />
        )}
      </div>
    )
  }
}

export default InstallDriftNotice



// WEBPACK FOOTER //
// ./src/scripts/components/GlobalNotificationBar/components/InstallDriftNotice/index.js